import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "items-center flex" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("span", { class: "mx-1" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        width: "24px",
        height: "24px",
        class: "inline-block"
    }, [
        /*#__PURE__*/ _createElementVNode("path", { d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" })
    ])
], -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("span", { class: "mx-1" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        width: "24px",
        height: "24px",
        class: "inline-block"
    }, [
        /*#__PURE__*/ _createElementVNode("path", { d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" })
    ])
], -1);
const _hoisted_4 = {
    key: 0,
    class: "absolute z-70 top-11 left-52 inline-block bg-white border-2 rounded border-gray-200"
};
const _hoisted_5 = { class: "items-center flex" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", { class: "mx-1" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        width: "24px",
        height: "24px",
        class: "inline-block"
    }, [
        /*#__PURE__*/ _createElementVNode("path", { d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" })
    ])
], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_folder_card = _resolveComponent("folder-card");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_folder_card, {
            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.openFolder(_ctx.folders[0]))),
            folder: _ctx.folders[0],
            showMenu: _ctx.index === 0,
            class: "rounded cursor-pointer text-sm w-48 md:w-60 md:my-2",
            small: "",
            onShowFolders: _cache[1] || (_cache[1] = id => _ctx.$emit('showFolders', id))
        }, null, 8, ["folder", "showMenu"]),
        _hoisted_3,
        _createElementVNode("div", {
            class: "rounded cursor-pointer w-12 flex justify-center text-sm p-1 border-gray-200 border-2 hover:border-yellow-400",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.open()), ["stop"]))
        }, "..."),
        (_ctx.openMenu)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders.slice(1, -2), (folder, index) => {
                    return (_openBlock(), _createBlock(_component_folder_card, {
                        key: `${folder.name}_${index}`,
                        folder: folder,
                        class: "rounded cursor-pointer text-sm w-48 md:w-60 border-none my-2",
                        onShowFolders: () => _ctx.openFolder(folder),
                        showMenu: false
                    }, null, 8, ["folder", "onShowFolders"]));
                }), 128))
            ], 512)), [
                [_vShow, _ctx.openMenu]
            ])
            : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders.slice(-2), (folder, index) => {
            return (_openBlock(), _createElementBlock("div", {
                key: folder.folderUuid,
                class: "flex-shrink-0"
            }, [
                _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createVNode(_component_folder_card, {
                        onClick: ($event) => (_ctx.openFolder(folder)),
                        folder: folder,
                        showMenu: index === 0,
                        class: "rounded cursor-pointer text-sm w-48 md:w-60 md:my-2",
                        small: "",
                        onShowFolders: _cache[3] || (_cache[3] = id => _ctx.$emit('openFolder', id))
                    }, null, 8, ["onClick", "folder", "showMenu"])
                ])
            ]));
        }), 128))
    ]));
}
